import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-5.0.10257",
  buildId: "5.0.10257",
  name: "Patch 10257",
  season: 0,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/aoe-iv-patch-10257",
  summary: "",
  introduction: `
![](https://www.ageofempires.com/wp-content/uploads/2022/01/PatchNote_1_2_2_DEL_1920x1080-1080x608.jpg)
""`,
  date: new Date("2022-01-12T19:29:35Z"),
  sections: [

  ],
};
